import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon, IconButton, Stack, Typography } from '@emburse/embark-core';
import { FileDownloadIcon } from '@emburse/embark-icons';
import { useCallback } from 'react';
export default function AgreementHeader({ file }) {
    const handleOpenInNewTab = useCallback(() => {
        window.open(file, '_blank');
    }, [file]);
    return (_jsxs(Stack, { justifyContent: "space-between", direction: "row", sx: { width: '98%' }, children: [_jsx(Typography, { color: "textSecondary", sx: { paddingLeft: 1 }, children: "Merchant Service Agreement (MSA)" }), _jsx(Stack, { direction: "row", alignItems: "center", children: _jsx(IconButton, { color: "primary", onClick: handleOpenInNewTab, children: _jsx(Icon, { iconUrl: FileDownloadIcon }) }) })] }));
}
